/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState, useEffect, Fragment} from 'react'
import {useIntl} from 'react-intl'
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import {PageTitle} from '../../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import {Col, Dropdown, Modal, Row, Spinner} from 'react-bootstrap'
import Pagination from 'react-bootstrap/Pagination'
import usePagination from 'utils/hooks/usePagination'
import {useNavigate} from 'react-router-dom'
import JobServices from '../../../../services/job'
import useServices from '../../../../utils/hooks/useServices'
import useDebounce from '../../../../utils/hooks/useDebounce'
import MasterServices from '../../../../services/master'
import UserServices from '../../../../services/user'
import {toast} from 'react-toastify'
import FormGenerator from '../../../../utils/helpers/FormGenerator'

let active = 1
let items: any = []
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>
  )
}

const heads = [
  {
    name: '',
    label: 'Email',
  },
  {
    name: '',
    label: 'Nama User',
  },
  {
    name: '',
    label: 'Status',
  },
  {
    name: '',
    label: 'Aksi',
  },
]

const ProfilePage: FC = () => {
  let navigate = useNavigate()
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })
  const [isEdit, setIsEdit] = useState(false)
  const [show, setShow] = useState(false)
  const [query, setQuery] = useState<any>({q: '', sort_order: 'desc'})
  const [formValue, setFormValue] = useState<any>({})
  const [submit, setSubmit] = useState(false)
  const [data, loading, empty, refresh, isError, setLoading] = useServices(
    UserServices.getProfile,
    {...query, page: pagination.page, sort_field: 'created_at', per_page: pagination.per_page},
    []
  )
  const paginator: any = usePagination({
    totalCount: data?.data?.total,
    pageSize: pagination.per_page || 10,
    currentPage: pagination.page || 1,
  })

  const [dataRole, loadingRole, emptyRole, refreshRole, isErrorRole, setLoadingRole] = useServices(
    MasterServices.getRole,
    {...query, page: 1, sort_field: 'created_at', per_page: 100},
    []
  )

  const [inputs, setInputs] = useState([
    {
      name: 'firstname',
      label: 'Nama Awal',
      type: '',
      validation: {},
      col: 6,
      options: [],
      additional: '',
    },
    {
      name: 'lastname',
      label: 'Nama Akhir',
      type: '',
      validation: {},
      col: 6,
      options: [],
      additional: '',
    },
    {
      name: 'gender',
      label: 'Jenis Kelamin',
      type: 'select',
      validation: {},
      col: 6,
      options: [
        {
          name: 'Pria',
          value: '1',
        },
        {
          name: 'Wanita',
          value: '0',
        },
      ],
      getItemValue: 'name',
      getItemValueId: 'value',
      additional: '',
    },
    {
      name: 'email',
      label: 'Email',
      disabled: true,
      type: '',
      validation: {},
      col: 6,
      options: [],
      additional: '',
    },
    // {
    //   name: 'role_id',
    //   label: 'Role',
    //   type: 'select2',
    //   validation: {},
    //   col: 6,
    //   options: [],
    //   additional: '',
    //   getItemValue: 'roles_name',
    //   getItemValueId: 'roles_id',
    // },
    // {
    //   name: 'code_phone',
    //   label: 'Kode',
    //   type: '',
    //   validation: {},
    //   col: 1,
    //   options: [],
    //   additional: '',
    // },
    {
      name: 'current_password',
      label: 'Password Sekarang',
      type: '',
      validation: {},
      col: 4,
      options: [],
      additional: '',
    },
    {
      name: 'password',
      label: 'Password Baru',
      type: 'password',
      validation: {},
      col: 4,
      options: [],
      additional: '',
    },
    {
      name: 'password_confirmation',
      label: 'Konfirmasi Password Baru',
      type: 'password',
      validation: {},
      col: 4,
      options: [],
      additional: '',
    },
    // {
    //   name: 'status',
    //   label: 'Status',
    //   type: 'select',
    //   validation: {},
    //   col: 6,
    //   options: [
    //     {
    //       name: 'Aktif',
    //       value: '1',
    //     },
    //     {
    //       name: 'Non-Aktif',
    //       value: '0',
    //     },
    //   ],
    //   getItemValue: 'name',
    //   getItemValueId: 'value',
    //   additional: '',
    // },
  ])

  useEffect(() => {
    refresh()
    generateTotalPage(pagination.total_page)
  }, [pagination.per_page, pagination.page])

  useEffect(() => {
    setFormValue({
      ...formValue,
      firstname: data?.users_firstname,
      lastname: data?.users_lastname,
      gender: data?.users_gender,
      email: data?.email,
      password: 'something',
      password_confirmation: 'something',
    })
  }, [data])

  useEffect(() => {
    // let clone = inputs
    // if (dataRole) {
    //   clone[4].options = dataRole?.data?.data
    // }
    // setInputs(clone)
  }, [dataRole])

  useDebounce(refresh, 250, [query.q, query.sort_order])

  const toggle = () => {
    if (show) {
      setFormValue({})
    }
    setShow(!show)
  }

  const generateTotalPage = (totalPage: number) => {
    let total = 0
    let newTotal: any = []

    for (total = 0; total < totalPage; total++) {
      if (total < 4) {
        newTotal.push(total + 1)
      } else if (total === 8) {
        newTotal.push('...')
        newTotal.push(totalPage)
      }
    }
    return newTotal
  }

  const onChangePerPage = (per_page: number, to_page = 1) => {
    setPagination({
      ...pagination,
      per_page: per_page,
      page: to_page || 1,
    })
  }

  const onChange = (e: any) => {
    const {name, value} = e.target
    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  const handleDelete = async (id: any) => {
    try {
      if (window.confirm('Yakin ingin men-non aktifkan User ?')) {
        setLoading(true)
        await MasterServices.deleteUser(id)
        toast.success(`User Berhasil Di Non-Aktifkan`)
        refresh()
      }
    } catch (error) {
    }
  }

  const onSubmit = async (e: any) => {
    try {
      setSubmit(true)
      e?.preventDefault()
      await UserServices.updateProfile(formValue)
      toast.success(`Berhasil Memperbarui data`)
      toggle()
      refresh()
    } catch (error) {
    } finally {
      setSubmit(false)
    }
  }

  return (
    <>
      <Row>
        <Col md={12}>
          <div className='card-custom'>
            <Row>{FormGenerator(inputs, formValue, onChange)}</Row>
            <Row>
              <Col md={12}>
                <Button style={{float: 'right'}} onClick={onSubmit}>
                  Update Profile
                </Button>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </>
  )
}

const MyProfile: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Akun Saya
      </PageTitle>
      <ProfilePage />
    </>
  )
}

export default MyProfile
